import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { getPartnerCampaigns } from "../../slices/partner/action";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../Components/Common/Pagination";
import CampaignDetails from "./CampaignDetails";
const Campaigns = () => {
  const dispatch = useDispatch();
  const { partnerCampaigns } = useSelector((state) => state.partner);
  const { rewardTypeMapping } = useSelector((state) => state.reward);

  const { totalPages, totalCount, campaigns } = partnerCampaigns;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getPartnerCampaignsFunc();
  }, [currentPage]);

  const getPartnerCampaignsFunc = async () => {
    await getPartnerCampaigns(
      { pageOffset: currentPage - 1, pageSize: pageSize },
      dispatch
    );
  };

  return (
    <div className="page-content px-4 pb-0">
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: " blur(4px)" }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Campaigns</h4>
          </div>

          <div className="table-responsive position-relative d-flex flex-column">
            <table className="table table-nowrap table-centered align-middle mb-0">
              <thead className="bg-light text-mute fs-14">
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Sponsored Amount</th>
                  <th>Sponsored Rewards</th>
                  {/* <th>No of Transactions</th> */}
                  <th>-</th>
                </tr>
              </thead>
              <tbody className="fs-13">
                {campaigns?.map((campaign, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <a href="#" className="text-muted cursor-grab d-block">
                          <i className="bx bx-grid-vertical fs-18 text-muted"></i>
                        </a>
                      </td>
                      <td>
                        <strong>{campaign?.launcherName}</strong>
                      </td>
                      <td>
                        <strong>
                          AED {campaign?.contributionAmount?.toFixed(2)}
                        </strong>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          {campaign?.rewardSummary?.map((reward) => {
                            return (
                              <div className="d-flex flex-row gap-1">
                                <div className="text-capitalize">
                                  <strong>{`${
                                    rewardTypeMapping?.[reward?.rewardTypeId]
                                      ?.name
                                  } :`}</strong>
                                </div>
                                <div>
                                  <strong>
                                    {reward?.contributionPoints?.toFixed(2)} Pts
                                  </strong>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                      {/* <td>{totalCount}</td> */}
                      <td>
                        <CampaignDetails campaign={campaign} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination
              totalPages={totalPages}
              totalItems={totalCount}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              itemsPerPage={pageSize}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Campaigns;
